import React from 'react';
import Button from '@mui/material/Button/Button';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

/**
 * A quiet link to the how-to guide for the screen you're on. Opens in a new tab, so a half-filled form or an open
 * score card stays where it was.
 */
export const HelpLink = ({ guide, children }: {
    // the guide's address under /how/to
    guide: string,
    // what the guide helps with, e.g. "Adding judges"
    children: React.ReactNode
}) => (
    <Button size="small" color="inherit" href={`/how/to/${guide}`} target="_blank" rel="noopener"
        startIcon={<HelpOutlineIcon fontSize="small" />}
        sx={{ alignSelf: 'flex-start', color: 'text.secondary', textTransform: 'none', fontWeight: 500, flexShrink: 0 }}>
        {children}
    </Button>
);
